import simpleBuilder from '@/helpers/dtos/simpleBuilder';
const keys = {
    ufLimiteUsado: 'uf',
    ufLimiteUsadoLimiteDisponivel: 'available',
    ufLimiteUsadoLimiteUtilizado: 'used',
    ufLimiteUsadoIdProduto: 'idProduct',
    ufLimiteUsadoDataLeitura: 'date',
};
export default simpleBuilder(keys);
